import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { GMB_MEDIA_EMAIL, NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import DownloadMediaKit from 'src/common/components/DownloadMediaKit';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('press-page');

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      variant="header"
    >
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography type="h1" size="display-3">
            {t('hero--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('hero--text')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            <Trans
              t={t}
              i18nKey="inquiry--text"
              values={{ mediaEmail: GMB_MEDIA_EMAIL }}
              components={{
                emailLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    className={styles.link}
                    href={`mailto:${GMB_MEDIA_EMAIL}`}
                    {...NEW_TAB_ATTRIBUTES}
                  />
                ),
              }}
            />
          </Typography>
        </div>
        <div className={styles.button}>
          <DownloadMediaKit />
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
